<template>
    <div>
      <!-- Start Header Area -->
      <Header>
        <img slot="logo" :src="logo" />
      </Header>
      <!-- End Header Area -->
  
      <!-- Start Breadcrump Area  -->
      <div
        class="rn-page-title-area pt--120 pb--190 bg_image bg_image--35"
        data-black-overlay="5"
      >
        <v-container>
          <v-row>
            <v-col cols="12">
              <div class="text-center rn-page-title pt--100">
                <h2 class="heading-title theme-gradient">
                  XFSDPH - Account Management System
                </h2>
                <p>
                  A comprehensive account management system built with Laravel and Vue.js, providing a user-friendly interface for managing accounts, transactions, and customers.
                </p>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <!-- End Breadcrump Area  -->
  
      <!-- Start Portfolio Details Area  -->
      <div class="rn-portfolio-details ptb--120 bg_color--1">
        <v-container>
          <v-row>
            <v-col>
              <div class="portfolio-details">
                <div class="row row--35 mb--50">
                  <div class="col-lg-6">
                    <div class="inner">
                      <div class="section-title">
                        <h2 class="heading-title" style="line-height: 50px !important;">XFSDPH - Account Management System</h2>
                        <p class="description mt--30">
                          A comprehensive account management system built with Laravel and Vue.js, providing a user-friendly interface for managing accounts, transactions, and customers. The system features real-time updates, drag-and-drop task management, and customizable project workflows to enhance team productivity.
                        </p>
                        <p class="description">
  
                          The application includes robust reporting tools, time tracking capabilities, and integration with popular third-party services, making it a complete solution for businesses of all sizes to streamline their account management processes.
                        </p>
                      </div>
                      <div class="flex-wrap portfolio-view-list d-flex">
                        <div class="port-view">
                          <span>Laravel/Vue.js</span>
                          <h4>Backend Development</h4>
                        </div>
                        <div class="port-view">
                          <span>Project Types</span>
                          <h4>Website</h4>
                        </div>
                        <div class="port-view">
                          <span>Program</span>
                          <h4>Creative Type</h4>
                        </div>
                      </div>
                      <div class="portfolio-details-btn mt--30">
                        <a
                          class="btn-default btn-border"
                          href="https://xfsdph.com"
                          target="_blank"
                          >Launch The Site</a
                        >
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div
                      class="portfolio-details-accordion mt_lg--40 mt_md--40 mt_sm--40"
                    >
                      <div class="inner">
                        <div class="section-title">
                          <h4 class="heading-title">Our Products</h4>
                          <p class="description mt--30">
                            Our account management system offers a suite of powerful features including account management, transaction management, and customizable workflows. The intuitive interface allows teams to easily manage accounts, transactions, and customers - all in real-time.
                          </p>
                          <p class="description mt--30">
                            We've integrated essential tools like account management, transaction management, and automated notifications to streamline account management and transaction workflows. The system also connects seamlessly with popular services like Stripe, PayPal, and Google Workspace to create a unified account management and transaction experience.
                          </p>
                          <ul class="list-style--1">
                            <li v-for="list in listOne" :key="list.id">
                              <i v-html="iconSvg(list.icon)"></i>
                              {{ list.desc }}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="portfolio-thumb-inner">
                  <div class="thumb mb--30">
                    <img
                      src="../../assets/images/portfolio/portfolio-big-08.png"
                      alt="Portfolio Images"
                    />
                  </div>
                  <div class="thumb">
                    <img
                      src="../../assets/images/portfolio/portfolio-big-09.png"
                      alt="Portfolio Images"
                    />
                  </div>
                  <div class="thumb">
                    <img
                      src="../../assets/images/portfolio/portfolio-big-10.png"
                      alt="Portfolio Images"
                    />
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <!-- End Portfolio Details Area  -->
  
      <Footer />
    </div>
  </template>
  
  <script>
    import Header from "../../components/header/Header";
    import Footer from "../../components/footer/Footer";
    import feather from "feather-icons";
  
    export default {
      components: {
        Header,
        Footer,
      },
      data() {
        return {
          logo: require("../../assets/images/logo/logo-ko.png"),
          items: [
            {
              thumb: require("../../assets/images/portfolio/portfolio-big-03.jpg"),
              src: "https://www.youtube.com/watch?v=ZOoVOfieAF8",
            },
          ],
          listOne: [
            {
              id: 1,
              icon: "check", 
              desc: `Modern and responsive user interface design`,
            },
            {
              id: 2,
              icon: "check",
              desc: `Secure backend API integration`,
            },
            {
              id: 3,
              icon: "check",
              desc: `Cross-platform mobile compatibility`,
            },
            {
              id: 4,
              icon: "check",
              desc: `Optimized database performance`,
            },
          ],
          socialList: [
            {
              url: "https://www.facebook.com/",
              icon: "facebook",
            },
            {
              url: "https://www.linkedin.com/",
              icon: "linkedin",
            },
            {
              url: "https://instagram.com/",
              icon: "instagram",
            },
            {
              url: "https://twitter.com/",
              icon: "twitter",
            },
          ],
          moreProjects: [
            {
              src: require("../../assets/images/portfolio/related-image-01.jpg"),
              title: "Digital Analysis",
              categorie: "Technique",
            },
            {
              src: require("../../assets/images/portfolio/related-image-02.jpg"),
              title: "Plan Management",
              categorie: "Planning",
            },
          ],
          index: null,
        };
      },
      methods: {
        iconSvg(icon) {
          return feather.icons[icon].toSvg();
        },
      },
    };
  </script>
  